/* eslint-disable no-template-curly-in-string */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { FC, useEffect, useState } from 'react';
import { Grid, Button, Box, Typography } from '@mui/material';
import { useAppDispatch } from '@hooks/redux-custom';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState, ContentState } from 'draft-js';
import './EmailTemplate.css';
import { convertToHTML } from 'draft-convert';
import htmlToDraft from 'html-to-draftjs';
import { SubTitle, LoadingSpinner } from '@components';
import { useGetEmailTemplatesQuery, useUpdateEmailTemplateMutation } from '@services';
import { showToast } from '@store/slices/notification';
import { addErrorToLog } from '@store/slices/error-log';
import { JimboResponse } from '@models';

const EmailTemplate: FC = () => {
  const { data, isFetching, refetch } = useGetEmailTemplatesQuery();
  const [updateEmailTemplate, { isLoading }] = useUpdateEmailTemplateMutation();
  const dispatch = useAppDispatch();

  const [emailTemplate, setEmailTemplate] = useState<any>(() => EditorState.createEmpty());

  useEffect(() => {
    if (data?.template) {
      const blocksFromHtml = htmlToDraft(data?.template);
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
      const contentToEditor = EditorState.createWithContent(contentState);

      setEmailTemplate(contentToEditor);
    }
  }, [data?.template]);

  const saveTemplate = async () => {
    await updateEmailTemplate({
      id: data?.id,
      template: convertToHTML(emailTemplate.getCurrentContent()),
    })
      .unwrap()
      .then(() => {
        dispatch(
          showToast({
            message: `Successfully updated the email template!`,
            type: 'success',
          }),
        );

        refetch();
      })
      .catch((error: { data: JimboResponse }) => {
        dispatch(addErrorToLog(error?.data));

        dispatch(
          showToast({
            message: `Failed to update the email template !`,
            type: 'error',
          }),
        );
      });
  };

  if (isFetching || isLoading) return <LoadingSpinner isOpen={isFetching || isLoading} />;

  const handleEditorChange = (state: any) => {
    setEmailTemplate(state);
  };

  return (
    <>
      <SubTitle title="Email Template" />
      <Box pb={2}>
        <Grid container spacing={2} data-testid="email-template">
          <Grid item xs={12}>
            <Editor
              editorState={emailTemplate}
              wrapperClassName="wrapper-class"
              editorClassName="editor-class"
              toolbarClassName="toolbar-class"
              onEditorStateChange={handleEditorChange}
            />
          </Grid>

          <Grid item xs={2}></Grid>
          <Grid item xs={10}>
            <Typography variant="body1">use the following placeholder to replace with actual value</Typography>
            <Typography variant="subtitle1">
              {'${username}'}, {'${phone_number}'}, {'${email}'}
            </Typography>
          </Grid>
          <Grid item xs={10}></Grid>
          <Grid item xs={2}>
            <Button variant="contained" fullWidth onClick={saveTemplate} data-testid="email-template-save-button">
              Save Template
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default EmailTemplate;
